import { i18n } from 'app/utils/i18n';

// The toggle has two axes. Tables use Cell/Table; prose carriers (paragraph, list)
// use Text/Block. See .claude/specs/block-tagging-paragraphs-lists.
export type BlockScope = 'cell' | 'table' | 'text' | 'block';
export type ScopeAxis = 'table' | 'prose';

const AXIS_OPTIONS: Record<ScopeAxis, [BlockScope, BlockScope]> = {
  table: ['cell', 'table'],
  prose: ['text', 'block'],
};

interface ScopeToggleProps {
  scope: BlockScope;
  onChange: (next: BlockScope) => void;
  axis?: ScopeAxis;
}

export const ScopeToggle = ({ scope, onChange, axis = 'table' }: ScopeToggleProps) => {
  const options = AXIS_OPTIONS[axis];
  return (
    <div className="tags-footer__scope" role="radiogroup" aria-label={i18n('tag.scope.label')}>
      {options.map((value) => (
        <label key={value} className="tags-footer__scope-option">
          <input type="radio" name="block-tag-scope" value={value} checked={scope === value} onChange={() => onChange(value)} />
          {i18n(`tag.scope.${value}`)}
        </label>
      ))}
    </div>
  );
};
